<template>
    <div class="form-elements">
        <div class="row w-100" v-show="!download.load">
            <div class="col-md-12 p-0">
                <button @click="getTeoricasAguardandoProcessamento()" class="btn btn-dark btn-micro w-100">Gerar Relatório</button>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import RelatoriosController from '../RelatoriosController'
import DashboardController from '../../dashboard/DashboardController'

export default {
    name: 'AgendadasHoje',
    components: {
        ...spinners,
    },

    data () {
        return {
            download: {
                load: false
            },
            dataInicial: '',
            dataFinal: ''
        }
    },

    methods: {

        getTeoricasAguardandoProcessamento()
        {
            this.download.load = true

            // RelatoriosController.getTeoricasAguardandoProcessamento(response => {
            //     if(response.sucesso === false) {
            //         this.download.load = false
            //     } else {
            //         console.log(response.dados)
            //         var pdf = 'data:application/octet-stream;base64,' + response.dados;
            //         var dlnk = document.getElementById('downloadPDF');
            //         dlnk.download="teoricas_aguardando_processamento.pdf";
            //         dlnk.href = pdf;
            //         dlnk.click();
            //         this.download.load = false
            //     }
            // })
            DashboardController.exportClassTheoryAwaitingProcessing(response => {
                let csv = 'data:text/csv;charset=utf-8,' + response
                let dlnk = document.getElementById('downloadCSV')
                dlnk.download = 'novoCFC.csv'
                dlnk.href = csv
                dlnk.click()
                this.download.load = false
            })
        },

        launchToast(icon, msg)
        {
            this.$toasted.show(msg, {
                position: 'top-right',
                icon: icon
            });
        }

    }
}
</script>